import React, { useState, useEffect } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { loginUser } from "./Apihelper/ApiHelper.js";
import AppToast from '../components/Toast/AppToast';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1B4332',
    },
    secondary: {
      main: '#64748b',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export default function SignIn() {
  const navigate = useNavigate();
  const [toastmessage, settoastmessage] = useState('');
  const [toastcolor, settoastcolor] = useState('info');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    // Check for remembered credentials
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    const rememberedPassword = localStorage.getItem('rememberedPassword');
    if (rememberedEmail && rememberedPassword) {
      setRememberMe(true);
      // You can set these values in your Formik initial values
      initialValues.email = rememberedEmail;
      initialValues.password = rememberedPassword;
    }
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
      setSnackbarOpen(false);
  };

  const handleForgotPasswordClick = () => {
    navigate('/forgotpassword');
};

    const initialValues = {
    email: '',
    password: '',
  };

  const handleRememberMe = (event) => {
    setRememberMe(event.target.checked);
  };
  
  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
        setSubmitting(false);
    try {
      const userData = new FormData();
      userData.append("email", values.email);
      userData.append("password", values.password);
  
      const res = await loginUser(userData);
  
      if (res.code == "200") {
        // Handle Remember Me
        if (rememberMe) {
          localStorage.setItem('rememberedEmail', values.email);
          localStorage.setItem('rememberedPassword', values.password);
        } else {
          localStorage.removeItem('rememberedEmail');
          localStorage.removeItem('rememberedPassword');
        }
     
        setLoading(false); 
        localStorage.setItem('userdata', JSON.stringify(res.admin));
     navigate('/dashboard', { state: { showSnackbar: true } });
     settoastmessage('Login Successful ! Welcome Back!');
     setSnackbarOpen(true);
      } else if(res.code == "500") {
        settoastmessage(res.message);
        settoastcolor('error');
        setLoading(false); 
        setSnackbarOpen(true);
      }else{
        settoastmessage(res.message);
        settoastcolor('error');
        setLoading(false); 
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error:", error);
      settoastmessage(error.message);
      setSnackbarOpen(true);
      setLoading(false); 
    } 
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${process.env.PUBLIC_URL}/whole-bg.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', px: 2 }}>
          <Paper
            elevation={0}
            sx={{
              width: { xs: '88vw', sm: '420px' },
              height: { xs: '88vw', sm: '420px' },
              maxWidth: 440,
              maxHeight: 440,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.12)',
              backdropFilter: 'blur(18px)',
              WebkitBackdropFilter: 'blur(18px)',
              border: '1.5px solid rgba(255, 255, 255, 0.35)',
              boxShadow: '0 8px 40px rgba(0, 0, 0, 0.35)',
              transition: 'all 0.3s ease-in-out',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 12px 40px rgba(0, 0, 0, 0.25)',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                width: '72%',
              }}
            >
              <Box
                component="img"
                src={`${process.env.PUBLIC_URL || ''}/images/rectangle-9@2x.png`}
                alt="Maa Tara Tarini Multi gym"
                sx={{ width: 80, height: 80, objectFit: 'contain' }}
              />
              <Typography
                component="h1"
                variant="body1"
                sx={{ fontWeight: 700, color: '#fff', textAlign: 'center', fontSize: '0.95rem', textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}
              >
                Maa Tara Tarini Multi gym
              </Typography>

              <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ isSubmitting }) => (
                  <Form style={{ width: '100%' }}>
                    <Box sx={{ width: '100%' }}>
                      <Field
                        as={TextField}
                        margin="dense"
                        size="small"
                        required
                        fullWidth
                        id="email"
                        label="Login ID"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            color: '#fff',
                            background: 'transparent',
                            '& fieldset': { borderColor: 'rgba(255,255,255,0.6)' },
                            '&:hover fieldset': { borderColor: '#fff' },
                            '&.Mui-focused fieldset': { borderColor: '#fff' },
                          },
                          '& .MuiInputBase-input': { background: 'transparent' },
                          '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.8)' },
                          '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
                          '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
                            WebkitBoxShadow: '0 0 0 100px transparent inset !important',
                            boxShadow: '0 0 0 100px transparent inset !important',
                            WebkitTextFillColor: '#fff !important',
                            caretColor: '#fff',
                            transition: 'background-color 9999s ease-in-out 0s',
                          },
                        }}
                      />
                      <Field
                        as={TextField}
                        margin="dense"
                        size="small"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            color: '#fff',
                            background: 'transparent',
                            '& fieldset': { borderColor: 'rgba(255,255,255,0.6)' },
                            '&:hover fieldset': { borderColor: '#fff' },
                            '&.Mui-focused fieldset': { borderColor: '#fff' },
                          },
                          '& .MuiInputBase-input': { background: 'transparent' },
                          '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.8)' },
                          '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
                          '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
                            WebkitBoxShadow: '0 0 0 100px transparent inset !important',
                            boxShadow: '0 0 0 100px transparent inset !important',
                            WebkitTextFillColor: '#fff !important',
                            caretColor: '#fff',
                            transition: 'background-color 9999s ease-in-out 0s',
                          },
                        }}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={rememberMe}
                            onChange={handleRememberMe}
                            size="small"
                            color="primary"
                          />
                        }
                        label={<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.85)' }}>Remember me</Typography>}
                        sx={{ mt: 0.5 }}
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                        sx={{
                          mt: 0.5,
                          display: 'block',
                          mx: 'auto',
                          px: 4,
                          py: 0.6,
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          textTransform: 'none',
                          borderRadius: '20px',
                          background: 'linear-gradient(45deg, #16a34a 30%, #22c55e 90%)',
                          boxShadow: '0 4px 12px rgba(22, 163, 74, 0.4)',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #15803d 30%, #16a34a 90%)',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 6px 16px rgba(22, 163, 74, 0.5)',
                          },
                        }}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : 'Sign In'}
                      </Button>
                      <Box sx={{ textAlign: 'center', mt: 0.5 }}>
                        <Link
                          component="button"
                          variant="caption"
                          onClick={handleForgotPasswordClick}
                          sx={{
                            color: 'rgba(255,255,255,0.9)',
                            textDecoration: 'none',
                            fontWeight: 500,
                            '&:hover': { color: '#fff', textDecoration: 'underline' },
                          }}
                        >
                          Forgot password?
                        </Link>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Paper>
        </Box>
       
      <AppToast open={snackbarOpen} message={toastmessage} severity={toastcolor} onClose={handleSnackbarClose} />
    </Box>
    </ThemeProvider>
  );
}